module.exports = __webpack_public_path__ + "img/CLAM-alt.f497c482.svg";